module.exports = {
  marks: [
  { 
    label: '1m',
    key:'1 million',
    value: 0,
    standardPrice: 500,  
    enterprisePrice: 2000,
    mcPrice: 0,
    yAxisCoordinate: 570, 
  },
  {
    label: '10m',
    key:'10 million',
    value: 10,
    standardPrice: 630,
    enterprisePrice: 2500,
    mcPrice: 0,
    yAxisCoordinate: 400, 
  },
  {
    label: '20m',
    key:'20 million',
    value: 20,
    standardPrice: 720,
    enterprisePrice: 2880,
    mcPrice: 0,
    yAxisCoordinate: 270, 
  },
  {
    label: '50m',
    key:'50 million',
    value: 35,
    standardPrice: 900,
    enterprisePrice: 3600,
    mcPrice: 0,
    yAxisCoordinate: 126, 
  },
  {
    label: '100m',
    key:'100 million',
    value: 50,
    standardPrice:  1100,
    enterprisePrice: 4400,
    mcPrice: 0,
    yAxisCoordinate: 113, 
  },
  {
    label: '300m',
    key:'300 million',
    value: 70,
    standardPrice: 1650,
    enterprisePrice: 0, // contact us
    mcPrice: 0,
    yAxisCoordinate: 97.5, 
  },
  {
    label: '1b',
    key:'1 billion',
    value: 90,
    standardPrice: 2700,
    enterprisePrice: 0, // contact us   
    mcPrice: 0,
    yAxisCoordinate: 86, 
  },
  {
    label: '10b',
    key:'10 billion',
    value: 99,
    standardPrice: 7000,
    enterprisePrice: 0, // contact us   
    mcPrice: 0,
    yAxisCoordinate: 85, 
  },
]
}